import { captureAuthLink } from "./lib/authLink";

captureAuthLink();
void import("./main");
